const prefix = process.env.VUE_APP_API_PREFIX

export default [{
  name: 'tableQuery',
  path: `${prefix}/order/cashList`,
  method: 'get',
  params: {
    page: 1,
    limit: 10,
    id: '',
    startTime: '',
    endTime: ''
  },
  desc: '收支记录列表'
}]
